const inviteType = {
    Manual: 'Manual',
    BulkUpload: 'BulkUpload',
    SignUpLink: 'SignUpLink'
  };
  
export default inviteType;


// WEBPACK FOOTER //
// ./src/constants/invite-type.js